import { getImageBase64, getBackground, getThemePic } from "@/views/home/slidePPT/use/methods";

const nodule = async (data) => {
  const node = data.node;
  const color = data.color;
  const id = Math.random().toString(36).slice(-8);
  const imgsrcList = await getImageBase64(node.title, 3);
  const background = await getBackground(data?.customTheme)


  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "d13_y_Eg5s",
        width: 283.4740813648294,
        height: 250.63664698162728,
        left: 48.63631889763779,
        top: 225.29650590551182,
        viewBox: [283.4740813648294, 250.63664698162728],
        path: "M 31.32958087270341 0 L 252.14450049212596 0 Q 283.4740813648294 0 283.4740813648294 31.32958087270341 L 283.4740813648294 219.30706610892386 Q 283.4740813648294 250.63664698162728 252.14450049212596 250.63664698162728 L 31.32958087270341 250.63664698162728 Q 0 250.63664698162728 0 219.30706610892386 L 0 31.32958087270341 Q 0 0 31.32958087270341 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        pathFormula: "roundRect",
        keypoint: 0.125,
        opacity: 0.5,
      },
      {
        type: "shape",
        id: "0Fnzekqtcn",
        width: 283.4740813648294,
        height: 250.63664698162728,
        left: 358.2629593175853,
        top: 225.29650590551182,
        viewBox: [283.4740813648294, 250.63664698162728],
        path: "M 31.32958087270341 0 L 252.14450049212596 0 Q 283.4740813648294 0 283.4740813648294 31.32958087270341 L 283.4740813648294 219.30706610892386 Q 283.4740813648294 250.63664698162728 252.14450049212596 250.63664698162728 L 31.32958087270341 250.63664698162728 Q 0 250.63664698162728 0 219.30706610892386 L 0 31.32958087270341 Q 0 0 31.32958087270341 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        pathFormula: "roundRect",
        keypoint: 0.125,
        opacity: 0.5,
      },
      {
        type: "shape",
        id: "DLi3b-zDE1",
        width: 283.4740813648294,
        height: 250.63664698162728,
        left: 667.1338582677165,
        top: 225.29650590551182,
        viewBox: [283.4740813648294, 250.63664698162728],
        path: "M 31.32958087270341 0 L 252.14450049212596 0 Q 283.4740813648294 0 283.4740813648294 31.32958087270341 L 283.4740813648294 219.30706610892386 Q 283.4740813648294 250.63664698162728 252.14450049212596 250.63664698162728 L 31.32958087270341 250.63664698162728 Q 0 250.63664698162728 0 219.30706610892386 L 0 31.32958087270341 Q 0 0 31.32958087270341 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        pathFormula: "roundRect",
        keypoint: 0.125,
        opacity: 0.5,
      },
      {
        type: "shape",
        id: "5A4zNmobVy",
        width: 134.7004593175853,
        height: 134.7004593175853,
        left: 432.64977034120733,
        top: 109.36031824146981,
        viewBox: [200, 200],
        path: "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: -45,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        flipV: true,
        flipH: true,
      },
      {
        type: "text",
        id: "w2K62Q4JRm",
        width: 248.0843996062992,
        height: 26.390583989501312,
        left: 375.9577591863517,
        top: 279.25,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: center;"><strong><span style="font-size: 21.09375px;font-family: Microsoft Yahei;">${node.children[1].title || ""
          }</span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "gPoKBLJQVo",
        width: 243.1615813648294,
        height: 129.59375,
        left: 378.4192093175853,
        top: 321.77805118110234,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: center;"><span style="font-size: 15.625px;font-family: Microsoft Yahei;">${node.children[1].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "5yM7pKFy6v",
        width: 45.570291994750654,
        height: 6.701525590551181,
        left: 477.21489501312334,
        top: 453.14804790026244,
        viewBox: [45.570291994750654, 6.701525590551181],
        path: "M 0.8376906988188976 0 L 44.73260129593176 0 Q 45.570291994750654 0 45.570291994750654 0.8376906988188976 L 45.570291994750654 5.863834891732283 Q 45.570291994750654 6.701525590551181 44.73260129593176 6.701525590551181 L 0.8376906988188976 6.701525590551181 Q 0 6.701525590551181 0 5.863834891732283 L 0 0.8376906988188976 Q 0 0 0.8376906988188976 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        pathFormula: "roundRect",
        keypoint: 0.125,
      },
      {
        type: "shape",
        id: "OuO5Th_-cx",
        width: 134.7004593175853,
        height: 134.7004593175853,
        left: 123.02312992125984,
        top: 109.36031824146981,
        viewBox: [200, 200],
        path: "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: -45,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        flipV: true,
        flipH: true,
      },
      {
        type: "text",
        id: "XNfILGeREw",
        width: 248.0843996062992,
        height: 26.390583989501312,
        left: 66.33120078740157,
        top: 279.25,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: center;"><strong><span style="font-size: 21.09375px;font-family: Microsoft Yahei;">${node.children[0].title || ""
          }</span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "qMS0UKBMyN",
        width: 243.1615813648294,
        height: 129.59375,
        left: 68.79256889763779,
        top: 321.77805118110234,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: center;"><span style="font-size: 15.625px;font-family: Microsoft Yahei;">${node.children[0].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "j7VzHWwwp0",
        width: 45.570291994750654,
        height: 6.701525590551181,
        left: 167.58825459317586,
        top: 453.14804790026244,
        viewBox: [45.570291994750654, 6.701525590551181],
        path: "M 0.8376906988188976 0 L 44.73260129593176 0 Q 45.570291994750654 0 45.570291994750654 0.8376906988188976 L 45.570291994750654 5.863834891732283 Q 45.570291994750654 6.701525590551181 44.73260129593176 6.701525590551181 L 0.8376906988188976 6.701525590551181 Q 0 6.701525590551181 0 5.863834891732283 L 0 0.8376906988188976 Q 0 0 0.8376906988188976 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        pathFormula: "roundRect",
        keypoint: 0.125,
      },
      {
        type: "shape",
        id: "djMx3OWK5e",
        width: 134.7004593175853,
        height: 134.7004593175853,
        left: 741.5206692913385,
        top: 109.36031824146981,
        viewBox: [200, 200],
        path: "M 100 0 A 100 100 102 1 0 200 100 L 200 0 L 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: -45,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        flipV: true,
        flipH: true,
      },
      {
        type: "text",
        id: "iImGvPMWTC",
        width: 248.0843996062992,
        height: 26.390583989501312,
        left: 684.8287401574803,
        top: 279.25,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: center;"><strong><span style="font-size: 21.09375px;font-family: Microsoft Yahei;">${node.children[2].title || ""
          }</span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "njKQBaHgy0",
        width: 243.1615813648294,
        height: 129.59375,
        left: 687.2901082677165,
        top: 321.77805118110234,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: center;"><span style="font-size: 15.625px;font-family: Microsoft Yahei;">${node.children[2].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "1kafouObdR",
        width: 45.570291994750654,
        height: 6.701525590551181,
        left: 786.0857119422573,
        top: 453.14804790026244,
        viewBox: [45.570291994750654, 6.701525590551181],
        path: "M 0.8376906988188976 0 L 44.73260129593176 0 Q 45.570291994750654 0 45.570291994750654 0.8376906988188976 L 45.570291994750654 5.863834891732283 Q 45.570291994750654 6.701525590551181 44.73260129593176 6.701525590551181 L 0.8376906988188976 6.701525590551181 Q 0 6.701525590551181 0 5.863834891732283 L 0 0.8376906988188976 Q 0 0 0.8376906988188976 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        pathFormula: "roundRect",
        keypoint: 0.125,
      },
      {
        type: "text",
        id: "N2X7ZdburH",
        width: 820.500997375328,
        height: 57.5,
        left: 89.74950131233598,
        top: 29.14288713910761,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><strong><span style="font-size: 25px;font-family: Microsoft Yahei;">${node.title || ""
          }</span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "image",
        id: "uQ-zT-7S5E",
        src: imgsrcList[0],
        width: 121.01599409448819,
        height: 121.01599409448819,
        left: 129.86540354330708,
        top: 116.20259186351706,
        fixedRatio: true,
        rotate: 0,
        clip: {
          shape: "ellipse",
          range: [
            [0, 0],
            [100, 100],
          ],
        },
      },
      {
        type: "image",
        id: "NzfUFNexMb",
        src: imgsrcList[1],
        width: 121.01599409448819,
        height: 121.01599409448819,
        left: 439.4919619422572,
        top: 116.20259186351706,
        fixedRatio: true,
        rotate: 0,
        clip: {
          shape: "ellipse",
          range: [
            [0, 0],
            [100, 100],
          ],
        },
      },
      {
        type: "image",
        id: "2d1Jit7e43",
        src: imgsrcList[2],
        width: 121.01599409448819,
        height: 121.01599409448819,
        left: 748.1213090551181,
        top: 116.20259186351706,
        fixedRatio: true,
        rotate: 0,
        clip: {
          shape: "ellipse",
          range: [
            [0, 0],
            [100, 100],
          ],
        },
      },
      {
        type: "shape",
        id: "nR9HVsY6gP",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 29.14288057742782,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "7aMOtHGQL_",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 28.90100065616798,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "K-x_oM9Zyl",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 29.041748687664043,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "k0FMpMDXzQ",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 29.777477034120736,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "8csSljinQS",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 29.438484251968504,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "T-015XvyVB",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 38.80282152230971,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "at7U2SFu4N",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 38.560859580052494,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "RYpwFKyEW5",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 38.70168963254593,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "jemaBgMb4C",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 39.437417979002625,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "p0E3mpoy98",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 39.09842519685039,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "d-CWgHTGfj",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 48.4627624671916,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "lJU4o_dLp0",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 48.22080052493438,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "hhTnNQZfQ1",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 48.36154855643044,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "taIUIhdxA5",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 49.09727690288714,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "LdWee_CMvX",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 48.758284120734906,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "IPcn5EbgvK",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 58.122621391076116,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "SNMW0d64NV",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 57.88074146981627,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "aKbol-RLvb",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 58.02148950131234,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "_K5AaXvK-d",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 58.75721784776903,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "PZw0FT8vlF",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 58.418225065616795,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
    ],
    background,
  };
};

export default nodule;
